export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="bg-background-50 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                移动客户端
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
                随时随地追剧观影，手机端专属优化，更流畅的播放体验，更省流量的智能压缩技术。支持 iOS 与 Android 双平台，扫码即可下载色影视官方客户端。
              </p>
              <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 rounded-xl cursor-pointer">
                  <i className="ri-apple-fill text-2xl text-background-50"></i>
                  <div className="text-left">
                    <div className="text-xs text-background-50/60">Download on the</div>
                    <div className="text-sm font-semibold text-background-50">App Store</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 rounded-xl cursor-pointer">
                  <i className="ri-google-play-fill text-2xl text-background-50"></i>
                  <div className="text-left">
                    <div className="text-xs text-background-50/60">GET IT ON</div>
                    <div className="text-sm font-semibold text-background-50">Google Play</div>
                  </div>
                </div>
              </div>
              <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-shield-check-line text-primary-500"></i> 安全无毒
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-smartphone-line text-primary-500"></i> 全端适配
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-speed-mini-line text-primary-500"></i> 极速播放
                </span>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-10">
              <div className="relative w-56 md:w-64">
                <div className="rounded-3xl overflow-hidden bg-background-200 aspect-[9/16]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20streaming%20movie%20app%20interface%20with%20warm%20dark%20theme%2C%20movie%20posters%20thumbnails%2C%20clean%20UI%20design%2C%20cinematic%20content%20browsing%2C%20amber%20and%20gold%20accent%20colors%2C%20modern%20app%20design%20with%20film%20aesthetic&width=400&height=700&seq=app-mobile-screen&orientation=portrait"
                    alt="色影视移动客户端界面"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}